export const UPDATE_STATE_ARRIVAL_DEPATURE = "UPDATE_STATE_ARRIVAL_DEPATURE";
export const RESET_STATE_ARRIVAL_DEPATURE = "RESET_STATE_ARRIVAL_DEPATURE";

export const update_state_arrival_depature = () => {
    return {
        type: UPDATE_STATE_ARRIVAL_DEPATURE,
    };
};

export const reset_state_arrival_depature = () => {
    return {
        type: RESET_STATE_ARRIVAL_DEPATURE,
    };
};

export const updateStateArrivalDepature = () => {
    return (dispatch) => {
        dispatch(update_state_arrival_depature());
    };
};

export const resetStateArrivalDepature = () => {
    return (dispatch) => {
        dispatch(reset_state_arrival_depature());
    };
};